import { reducersActions } from "../actions/new-actions";



const initialState = {
    user: null,
    users: [],
    loading: false,
    errors: {},
};

export default function userReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case reducersActions.GET_USERS_REQUEST:
            return {
                ...state,
                loading: true,
                errors: {}, // clear previous errors
            };
        case reducersActions.GET_USERS:
            return {
                ...state,
                users: payload,
                loading: false,
            };
        case reducersActions.GET_USERS_ERROR:
            return {
                ...state,
                errors: payload,
                loading: false,
            };
        default:
            return state;
    }
}
